export interface EnvironmentConfig {
  environment: "dev" | "qa" | "prod";
  buildNumber: string;
  apiBaseUrl: string;
}

export interface InternalEnvironmentConfig extends EnvironmentConfig {
  /** Is the current code running in local development mode. */
  localDevelopmentMode?: boolean;
  /** Is the current code running inside an iframe. */
  isInIframe: boolean;
}

type WindowWithConfig = typeof window & { configuration?: EnvironmentConfig };

const environments: EnvironmentConfig["environment"][] = ["dev", "qa", "prod"];
const actualConfig: EnvironmentConfig | undefined = (window as WindowWithConfig).configuration;

const localhostConfig: EnvironmentConfig = {
  environment: "dev",
  buildNumber: "localDevelopment",
  apiBaseUrl: "https://api-dev.geomant.cloud",
};

const usedConfig = actualConfig && environments.includes(actualConfig.environment)
  ? actualConfig
  : localhostConfig;

const usedInternalConfig: InternalEnvironmentConfig = {
  ...usedConfig,
  localDevelopmentMode: window.location.hostname === "localhost",
  isInIframe: inIsIframe(),
};

export default Object.freeze(usedInternalConfig);

function inIsIframe() {
  try {
    return window.self !== window.top;
  }
  catch {
    return true;
  }
}
